import {
  ChangeEvent,
  Dispatch,
  SetStateAction,
  useState,
  ReactNode,
} from 'react';
import {
  FormControl,
  FormHelperText,
  InputAdornment,
  TextField,
} from '@mui/material';
import useAlias from '@src/hooks/useAlias';

function CommandsNumberInput({
  label,
  unit,
  minimum,
  maximum,
  value,
  currentValue,
  setValue,
}: {
  label: string | ReactNode;
  unit: string;
  minimum: number;
  maximum: number;
  value: string;
  currentValue: string | undefined;
  setValue: Dispatch<SetStateAction<string>>;
}) {
  const alias = useAlias();
  const [isValueValid, setIsValueValid] = useState(true);
  const translatedLabel = typeof label === 'string' ? alias(label) : label;
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const isValid =
      value.length > 0 &&
      parseFloat(value) <= maximum &&
      parseFloat(value) >= minimum;
    setIsValueValid(isValid);
    setValue(value);
  };

  return (
    <FormControl
      variant='outlined'
      sx={{ width: '100%', mt: 2.5 }}
      error={!isValueValid}
    >
      <TextField
        size='small'
        label={translatedLabel}
        InputProps={{
          endAdornment: <InputAdornment position='end'>{unit}</InputAdornment>,
        }}
        variant='filled'
        type='number'
        value={value}
        onChange={handleChange}
        onFocus={(event) => event.target.select()}
        error={!isValueValid}
      />
      <FormHelperText>
        {alias('Range from {min} to {max}', { min: minimum, max: maximum })}
        <br />
        {alias('Current value: {value}', { value: currentValue ?? '-' })}
      </FormHelperText>
    </FormControl>
  );
}

export default CommandsNumberInput;
